export default __webpack_public_path__ + "static/empower-f8cca5065bf21eb3ed244a57efd5b944.png";